module.exports = __webpack_public_path__ + "static/img/ba.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ba.png
// module id = fuM4
// module chunks = 1